export const ADD_SUCCESS = 'Фотографии добавлены';
export const ADD_ERROR = 'Не удалось добавить фотографии';
